import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  TextField,
  Button,
  Typography,
  Fab,
  Chip,
  Paper,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SmsIcon from "@material-ui/icons/Sms";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
// import Button from "react-bootstrap/Button";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";
import { API_ROOT, API_HOST } from "./utils/api-config";

import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import FilledInput from "@material-ui/core/FilledInput";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { Fragment } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
      // display: "flex",
      // flexWrap: "wrap",
    },
    margin: {
      margin: "10px",
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: "400px",
    },
  },
}));
function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}
const ShowTask = ({ task, history, updateTask }) => {
  const classes = useStyles();
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const [values, setValues] = useState({
    id: 0,
    title: "",
    name: "",
    address1: "",
    address2: "",
    city: "",
    province: "Ontario",
    postal_code: "",
    delivery_instructions: "",
    delivery_window: "",
    date: "",
    route_id: 0,
    complete: false,
    completed_at: null,
    task_type: "",
    neighborhood: "",
    latitude: "",
    longitude: "",
    merchant: "",
    pick_up: false,
    orders: {},
    delivery_ids: {},
    show: false,
  });

  useEffect(() => {
    setValues({
      id: task.task.id,
      title: task.task.title,
      name: task.task.name,
      address1: task.task.address1,
      address2: task.task.address2,
      city: task.task.city,
      postal_code: task.task.postal_code,
      delivery_instructions: task.task.delivery_instructions,
      delivery_window: task.task.delivery_window,
      date: task.task.date,
      route_id: task.task.route_id,
      complete: task.task.complete,
      completed_at: task.task.completed_at,
      task_type: task.task.task_type,
      neighborhood: task.task.neighborhood,
      latitude: task.task.latitude,
      longitude: task.task.longitude,
      merchant: task.task.merchant,
      pick_up: task.task.pick_up,
      delivery_ids: task.task.delivery_ids,
      orders: task.task.orders,
    });
    setLeft(task.orders);
  }, [task]);

  const onSave = () => {
    console.log(left);
    const ids = [];
    const orders = [];
    left.map((del) =>
      Object.keys(del).map((id) => {
        return (
          ids.push(id), orders.push(`${del[id].order} ${del[id].bags} bags`)
        );
      })
    );
    setValues({
      ...values,
      delivery_ids: ids,
      orders: orders,
    });
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShow = () => {
    setValues({ ...values, show: !values.show });
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const customList = (items) => (
    <Paper className={classes.paper}>
      <List dense component="div" role="list">
        {console.log(items)}
        {items.map((del, index) => {
          const labelId = `transfer-list-item-${index}-label`;
          return (
            <ListItem
              key={index}
              role="listitem"
              button
              onClick={handleToggle(del)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(del) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              {Object.keys(del).map((id) => (
                <ListItemText id={labelId} primary={del[id].order} />
              ))}
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Paper>
  );

  const getCoords = () => {
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    };
    formData.append("id", values.id);
    formData.append("address1", values.address1);
    formData.append("city", values.city);
    axios
      .post(`${API_ROOT}/tasks/get_coords`, formData, config)
      .then(({ data }) => console.log(data))
      .then(() => updateTask(values.id));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(values).map((item) =>
      item == "delivery_ids" || item == "orders"
        ? formData.append(`task[${item}]`, `,${values[item]},`)
        : formData.append(`task[${item}]`, values[item])
    );
    formData.append("commit", "update");

    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    axios
      .patch(`${API_ROOT}/tasks/${values.id}`, formData, config)
      .then((response) => console.log(response.data))
      .then(() => redirect());
  };

  const redirect = () => {
    history.push({ pathname: `/routes/${values.route_id}` });
  };
  return (
    <div className={classes.root}>
      <Typography gutterBottom variant="h5" component="h2">
        {task.task.title}
      </Typography>

      <Fab color="secondary" onClick={handleClickShow} aria-label="edit">
        <EditIcon />
      </Fab>

      {/* {task.created_by && (
        <Chip
          label={task.created_by}
          clickable
          color="primary"
          component="a"
          href={`/users/${task.created_by}`}
          clickable
        />
      )} */}
      <Chip
        label={
          task.task.complete
            ? "Completed"
            : task.task.started
            ? "Started"
            : "Not started"
        }
        clickable
        color={
          task.task.complete
            ? "primary"
            : task.task.started
            ? "primary"
            : "secondary"
        }
      />

      <Chip
        // icon={task.com == "delivered" ? <SmsIcon /> : <SmsFailedIcon />}
        label={task.task.merchant}
        color={"primary"}
      />
      <Chip
        label={`Route ${task.task.route_id}`}
        component={Link}
        to={`/routes/${task.task.route_id}`}
        clickable
        color={"secondary"}
      />
      {/* <Chip
        // icon={<AlternateEmailIcon />}
        label={task.task.route_id}
        color={"secondary"}
      /> */}
      {values.show ? (
        <Form>
          <Card className={classes.root}>
            <CardActionArea>
              <CardContent>
                <Typography variant="caption" display="block" gutterBottom>
                  Name
                </Typography>
                <Typography gutterBottom variant="h5" component="h2">
                  {task.task.name} {task.phone}
                </Typography>
                <Typography variant="caption" display="block" gutterBottom>
                  Address
                </Typography>
                <Typography gutterBottom variant="h5" component="h2">
                  {task.task.address1 +
                    " " +
                    (task.task.address2 ? task.task.address2 : "") +
                    " " +
                    task.task.city +
                    " " +
                    task.task.postal_code}
                </Typography>
                <Typography variant="caption" display="block" gutterBottom>
                  Neighborhood
                </Typography>
                <Typography gutterBottom variant="h5" component="h2">
                  {task.task.neighborhood}
                </Typography>
                <Typography variant="subtitle1" gutterBottom></Typography>
                <Typography variant="caption" display="block" gutterBottom>
                  Delivery Instructions
                </Typography>

                <Typography gutterBottom variant="h5" component="h5">
                  {task.task.delivery_instructions}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <Card className={classes.root}>
            <CardActionArea>
              <CardContent>
                <Typography variant="caption" display="block" gutterBottom>
                  Orders
                </Typography>
                {task.task.orders.map((order) => (
                  <Typography gutterBottom variant="h5" component="h2">
                    {order}
                  </Typography>
                ))}
              </CardContent>
            </CardActionArea>
          </Card>

          <Col md="3"></Col>
        </Form>
      ) : (
        <div>
          <br></br>
          <FormControl fullWidth className={classes.margin} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-title">Title</InputLabel>
            <OutlinedInput
              id="outlined-adornment-title"
              value={values.title}
              onChange={handleChange("title")}
              labelWidth={30}
            />
          </FormControl>
          <div>
            <TextField
              label="Name"
              id="name"
              value={values.name}
              onChange={handleChange("name")}
            />
          </div>
          <div>
            <TextField
              label="Address1"
              id="address1"
              value={values.address1}
              onChange={handleChange("address1")}
            />
            <TextField
              label="Address2"
              id="address2"
              value={values.address2}
              onChange={handleChange("address2")}
            />
            <TextField
              label="City"
              id="city"
              value={values.city}
              onChange={handleChange("city")}
            />
            <TextField
              label="Postal Code"
              id="postal_code"
              value={values.postal_code}
              onChange={handleChange("postal_code")}
            />
          </div>
          <div>
            <TextField
              label="Neighborhood"
              id="neighborhood"
              value={values.neighborhood}
              onChange={handleChange("neighborhood")}
            />
            <TextField
              label="Latitude"
              id="latitude"
              value={values.latitude}
              onChange={handleChange("latitude")}
            />
            <TextField
              label="Longitude"
              id="longitude"
              value={values.longitude}
              onChange={handleChange("longitude")}
            />
            <Button variant="contained" onClick={getCoords} color="primary">
              Get Coordinates
            </Button>
          </div>
          <FormControl fullWidth className={classes.margin}>
            <InputLabel htmlFor="delivery_instructions">
              Delivery Instructions
            </InputLabel>
            <Input
              id="delivery_instructions"
              value={values.delivery_instructions}
              onChange={handleChange("delivery_instructions")}
            />
          </FormControl>
          <div>
            <TextField
              label="Delivery Ids"
              id="delivery_ids"
              value={values.delivery_ids}
              onChange={handleChange("delivery_ids")}
            />
            <TextField
              label="Orders"
              id="orders"
              value={values.orders}
              onChange={handleChange("orders")}
            />
            {values.task_type == "pickup" && (
              <Fragment>
                <InputLabel htmlFor="orders"> Edit Orders</InputLabel>
                <Grid
                  container
                  spacing={2}
                  // justify="center"
                  alignItems="center"
                  className={classes.root}
                >
                  <Grid item>{customList(left)}</Grid>
                  <Grid item>
                    <Grid container direction="column" alignItems="center">
                      <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                        aria-label="move selected right"
                      >
                        &gt;
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                        aria-label="move selected left"
                      >
                        &lt;
                      </Button>
                      <Button
                        variant="contained"
                        onClick={onSave}
                        color="primary"
                      >
                        Edit
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item>{customList(right)}</Grid>
                </Grid>
              </Fragment>
            )}
          </div>
          <Button variant="contained" onClick={handleSubmit} color="primary">
            Submit
          </Button>
        </div>
      )}
    </div>
  );
};

export default withRouter(ShowTask);
